import type { OwaDate } from 'owa-datetime';
import { action } from 'satcheljs';
import type { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export const resetDayGrid = action('dayGrid-resetDayGrid', (scenarioId: string) => ({
    scenarioId,
}));

export const updateFolderIds = action(
    'dayGrid-updateFolderIds',
    (scenarioId: string, folderIds: string[]) => ({
        scenarioId,
        folderIds,
    })
);

export const navigateToDate = action(
    'dayGrid-navigateToDate',
    (scenarioId: string, newDate: OwaDate) => ({
        scenarioId,
        newDate,
    })
);

export const updateNumDaysInDayRange = action(
    'dayGrid-updateNumDaysInDayRange',
    (scenarioId: string, numDaysInDayRange: number) => ({
        scenarioId,
        numDaysInDayRange,
    })
);

export const updateDateRangeType = action(
    'dayGrid-updateDateRangeType',
    (scenarioId: string, dateRangeType: DateRangeType | undefined) => ({
        scenarioId,
        dateRangeType,
    })
);

export const updateSelectionItem = action(
    'dayGrid-updateSelectionItem',
    (scenarioId: string, selectionItem: CalendarEvent) => ({
        scenarioId,
        selectionItem,
    })
);
